// extracted by mini-css-extract-plugin
module.exports = {"modal":"RnWbbA","header":"LflhCs","title":"wTULyb","body":"qd0TJV","couponText":"zcwhlE","content":"c4kgrDl","b2c":"DnFDpH","b2b":"HQeZ1O"};